// https://github.com/Vahan0799/infinite-marquee?tab=readme-ov-file
if (!customElements.get('dm-sticky-add-to-cart')) {
  customElements.define(
    'dm-sticky-add-to-cart',
    class DMStickyAddToCart extends HTMLElement {
      constructor() {
        super();
        try {
          this.productHeroSection = document.querySelector('#product-hero-section');
          this.footerSection = document.querySelector('.shopify-section-group-footer-group');
          this.heroVisible = false;
          this.footerVisible = false;
          this.heroObserver = null;
          this.footerObserver = null;

          if (this.productHeroSection) {
            this.heroObserver = new IntersectionObserver(this.handleHeroIntersection.bind(this), {
              root: null,
              rootMargin: '0px',
              threshold: 0
            });
            this.heroObserver.observe(this.productHeroSection);
          } else {
            console.warn('DMStickyAddToCart: #product-hero-section not found. Showing sticky bar.');
            this.style.transform = 'none';
          }

          // Hide the sticky bar once the real footer comes into view, so it never
          // covers the footer content (payment icons, legal links, copyright).
          if (this.footerSection) {
            this.footerObserver = new IntersectionObserver(this.handleFooterIntersection.bind(this), {
              root: null,
              rootMargin: '0px',
              threshold: 0
            });
            this.footerObserver.observe(this.footerSection);
          }
        } catch (error) {
          console.error('Error initializing dm-sticky-add-to-cart:', error);
        }
      }

      updateVisibility() {
        if (this.heroVisible || this.footerVisible) {
          this.style.transform = 'translateY(100%)';
        } else {
          this.style.transform = 'none';
        }
      }

      handleHeroIntersection(entries) {
        entries.forEach(entry => {
          this.heroVisible = entry.isIntersecting;
        });
        this.updateVisibility();
      }

      handleFooterIntersection(entries) {
        entries.forEach(entry => {
          this.footerVisible = entry.isIntersecting;
        });
        this.updateVisibility();
      }

      disconnectedCallback() {
        if (this.heroObserver && this.productHeroSection) {
          this.heroObserver.unobserve(this.productHeroSection);
          this.heroObserver.disconnect();
        }
        if (this.footerObserver && this.footerSection) {
          this.footerObserver.unobserve(this.footerSection);
          this.footerObserver.disconnect();
        }
      }
    }
  );
}
